<app-grid
    [columns]="columns"
    [rows]="data.tableRows"
    [tableParams]="data.tableParams"
    [gridName]="gridName"
    [multiSelect]="false"
    [allowAdd]="false"
    [allowEdit]="false"
    [allowDelete]="false"
    [allowView]="false" 
    [allowExport]="false"   
    (refreshDataFromServer)="refreshData()"
   (rowSelected)="onRowClick($event)"
></app-grid>
